import * as React from "react";
import { BrowserRouter, Route, Link, Switch, Redirect } from "react-router-dom";
import { AdminHomePageModel } from '../../models/homePage/adminHomePageModel';
import HomePageService from '../../services/homePageService';
import { InputText } from "primereact/inputtext";
import { UserModel } from "../../models/user";
import { Button } from "primereact/button";
import Translate from "../../common/functions/translate";
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import AuthService from "../../services/authService";
import Spinner from '../../common/components/spinner/spinner';

interface IProps {
    history: any;
}

interface IState {
    isLoading: boolean;
    user: UserModel;
    isLogged: boolean;
    errorMessage: string;
}

class LoginComponent extends React.Component<IProps, IState> {
    authService = new AuthService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            user: new UserModel(),
            isLogged: false,
            errorMessage: '',
        };
    }

    componentDidMount() {

    }

    handleChange = (key, value) => {
        const user: UserModel = { ...this.state.user };
        user[key] = value;
        this.setState({ user: { ...user } });
    };

    isValidLoginForm() {
        this.setState({
            errorMessage: ''
        });

        let message = "";

        if (!this.state.user.email || this.state.user.email.trim() === "") {
            message += Translate('Please enter email') + "<br /> ";
        }

        if (!this.state.user.password || this.state.user.password.trim() === "") {
            message += Translate('Please enter password') + " ";
        }

        if (message !== "") {
            this.setState({
                errorMessage: message
            });
        }

        return message === "";
    }

    handleKeyPress = e => {
        if (e.key === "Enter") {
            this.handleLoginBtn();
        }
    };

    handleLoginBtn = () => {
        if (!this.isValidLoginForm()) return;

        this.setState({
            isLoading: true
        });

        const user = this.state.user;

        this.authService
            .login(user.email, user.password)
            .then((data: any) => {
                if (data) {
                    this.setState(
                        {
                            isLoading: false,
                            isLogged: data,
                            user: new UserModel()
                        }, () => this.redirectAfterLogin()
                    );
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    errorMessage: Translate(error.message)
                });
            });
    }

    redirectAfterLogin = () => {
        this.props.history.push('/');
    }


    render() {
        const { isLoading, user } = this.state;

        return (
            <div className="login-panel">
                <h2>Login</h2>

                {isLoading ? <Spinner /> : null}

                {this.state.errorMessage ? <div style={{ width: '30%' }}> <AlertMessage type='danger'>{this.state.errorMessage}</AlertMessage></div> : null}

                <div style={{ display: 'flex', flexDirection: 'column', width: '30%' }}>
                    <InputText
                        style={{ marginBottom: 5 }}
                        name="name"
                        placeholder="Email"
                        onChange={(e) => this.handleChange('email', e.target['value'])}
                        value={user && user.email ? user.email : ""}
                    />
                    <InputText
                        style={{ marginBottom: 5 }}
                        onKeyPress={this.handleKeyPress}
                        name="password"
                        type="password"
                        placeholder="Password"
                        onChange={(e) => this.handleChange('password', e.target['value'])}
                        value={user && user.password ? user.password : ""}
                    />
                    <Button
                        className="p-button-raised"
                        style={{ marginTop: 10 }}
                        label="Login"
                        onClick={this.handleLoginBtn}
                    />
                </div>

                {/* <div>
                    <div className="p-g p-fluid">
                        <div className="p-g-12" style={{ marginBottom: "20px" }}>
                            <TextField
                                name="email"
                                label={Translate('Email')}
                                type="email"
                                value={user && user.email ? user.email : ""}
                                onChange={(e) => this.handleChange('email', e.target['value'])}
                            />
                        </div>
                        <div className="p-g-12" style={{ marginBottom: "20px" }}>
                            <TextField
                                type="password"
                                name="password"
                                label={Translate('Password')}
                                onKeyPress={this.handleKeyPress}
                                onChange={(e) => this.handleChange('password', e.target['value'])}
                                value={user && user.password ? user.password : ""}
                            />
                        </div>

                        <div style={{ width: 200, marginTop: 30 }}>
                            <Button variant="contained" size="medium" color='primary' onClick={this.handleLoginButton}
                                style={{ width: '100%', marginBottom: '15px' }}>
                                {Translate('Login')}
                            </Button>
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }
}

export default LoginComponent;